module.exports = __webpack_public_path__ + "src/shared-components/customer-search/bluePlus.ecbfc6b65c297d0443a87cf57a6bdc59.svg";